// extracted by mini-css-extract-plugin
module.exports = {"label":"_3EUGdVihqu_calculator","angle":"_3s4OIHMoTL_calculator","textStyle":"_3NqWnpApJr_calculator"};